import React,{Component} from 'react';



class OrderFields extends Component{
    constructor(){
        super();
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.handleChangeLength = this.handleChangeLength.bind(this);
        this.state = {
            number : 0,
            length : 0,
            total : 0
        }
        
    }

    handleChangeNumber(e){
            this.setState({
                number : e.target.value
            })

    }

    handleChangeLength(e){
            this.setState({
                length : e.target.value
            })

    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.number!==this.state.number){
            let total = this.state.number * this.state.length
            this.setState({
                total
            })
        }

        if(prevState.length!==this.state.length){
            let total = this.state.number * this.state.length
            this.setState({
                total
            })
        }

        if(prevState.total!==this.state.total){
            let total = this.state.number * this.state.length
            this.props.setData(total,this.props.index,this.state.length,this.state.number)
        }
    }
          
    render() {

        return (
            
                <tr>
                    <td>
                        <input className="form-control"  ref="number" value = {this.state.number} type="text" required onChange={this.handleChangeNumber}/>                            
                    </td>
                        
                    <td>
                        <p> SHTS</p>
                    </td>
                        
                    <td>
                        <input className="form-control"  ref="length" value = {this.state.length} type="text" required onChange={this.handleChangeLength}/>
                        
                    </td>
                    <td>
                        <p> M</p> 
                    </td>
                    <td>
                        <p>{this.state.total}</p>
                        <input className="form-control"  ref="total" value={this.state.total}type="hidden" required/>
                    </td>
                    <td>
                        <button type="button" className="btn btn-sm btn-danger" onClick={()=>this.props.remove(this.props.count,this.props.index)}> x </button>
                    </td>
                </tr>
            
        );
    }
}

export default  OrderFields;



// WEBPACK FOOTER //
// ./src/components/OrderFields.js